module.exports = __webpack_public_path__ + "media/images/misc/made-in-germany-0b68fe1982187dd8caf834e858cebf20.png";